// extracted by mini-css-extract-plugin
export default {"Recovery":"Recovery_Recovery__GV5Sb","imageContainer":"Recovery_imageContainer__jLeMX"};